import { render, staticRenderFns } from "./Emojis.vue?vue&type=template&id=7b66c7b2&scoped=true&v=4"
import script from "./Emojis.vue?vue&type=script&lang=js&v=4"
export * from "./Emojis.vue?vue&type=script&lang=js&v=4"
import style0 from "./Emojis.vue?vue&type=style&index=0&id=7b66c7b2&scoped=true&lang=css&v=4"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b66c7b2",
  null
  
)

export default component.exports